import moment from 'moment';
import React from 'react';
// Full Paper Follow-Up Email
const EigthStepWhatsappTemplate = ({ values }) => {
  const {
    conference_short_name,
    client_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    submission_date_line,
    guideline,
    your_name,
  } = values;
  return (
    <div>
      <p>
        {client_name ? `Dear ${client_name},` : `Dear [Client Name],`}
      </p>

      <p>
        Thank you for registering for "
        {conference_short_name
          ? conference_short_name
          : '[Conference Short Name]'}
        " on
        {conference_from_date || conference_from_date
          ? `${conference_from_date} - ${conference_to_date}`
          : '[Conference from and to Date]'}
        at {conference_location ? conference_location : '[Conference Venue]'}.
        Please submit your full paper by{' '}
        {moment(submission_date_line)?.format('YYYY-MM-DD')
          ? submission_date_line
          : '[Submission Deadline]'}{' '}
        via [Submit Full Paper]. Follow {guideline ? guideline : '[guideline]'}{' '}
        for formatting. All accepted and registered papers may be published in
        Scopus/Web of Science journals. Contact us for assistance.
      </p>

      <div>Best regards,</div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
    </div>
  );
};

export default EigthStepWhatsappTemplate;
